import Icon from '../components/Icon';

const Weather25Colored = Icon(
  'weather-25-colored',
  <>
    <path d="M15 17.5a6 6 0 1 1-9.75-4.687V4.75a3.75 3.75 0 0 1 7.5 0v8.063A6 6 0 0 1 15 17.5m-1.5 0a4.5 4.5 0 0 0-1.93-3.694.75.75 0 0 1-.32-.618V4.75a2.25 2.25 0 0 0-4.5 0v8.438a.75.75 0 0 1-.32.614A4.5 4.5 0 1 0 13.5 17.5" />
    <path
      fill="#4C8BF9"
      d="m19.217 8.145 1.157 1.593a.75.75 0 1 1-1.213.882l-1.154-1.594-1.157 1.594a.75.75 0 0 1-1.213-.882l1.157-1.593-1.876-.609a.75.75 0 0 1 .464-1.427l1.875.61V4.75a.75.75 0 1 1 1.5 0v1.969l1.875-.609a.75.75 0 1 1 .464 1.427zM11.545 19.087a3 3 0 0 0-1.795-4.493V11.5a.75.75 0 1 0-1.5 0v3.094a3 3 0 1 0 3.295 4.493"
    />
  </>
);

export default Weather25Colored;
